import createReducer from 'store/createReducer';
import * as types from './types';

const initialState = {
  isLogged: false,
  loading: false,
  registrationLoading: false,
  error: undefined,
  alreadyRedirect: false,
  data: {},
};

const ProfileReducer = createReducer(initialState, {
  [types.LOGIN](state, action) {
    return {
      ...state,
      loading: true,
    };
  },
  [types.LOGIN_SUCCESS](state, action) {
    return {
      ...state,
      loading: false,
      isLogged: true,
      data: action.payload,
    };
  },
  [types.LOGIN_ERROR](state, action) {
    return {
      ...state,
      isLogged: false,
      loading: false,
    };
  },

  /* ----------------- */

  [types.GET_USER](state, action) {
    return {
      ...state,
      loading: true,
    };
  },
  [types.GET_USER_SUCCESS](state, action) {
    return {
      ...state,
      loading: false,
      isLogged: true,
      data: action.payload,
    };
  },
  [types.GET_USER_ERROR](state, action) {
    return {
      ...state,
      isLogged: false,
      loading: false,
    };
  },
  /* ---------------- */
  [types.REGISTRATION_REQUEST](state, action) {
    return {
      ...state,
      registrationLoading: true,
    };
  },
  [types.REGISTRATION_REQUEST_SUCCESS](state, action) {
    return {
      ...state,
      registrationLoading: false,
      alreadyRedirect: false,
      data: action.payload,
    };
  },
  [types.REGISTRATION_REQUEST_ERROR](state, action) {
    return {
      ...state,
      registrationLoading: false,
    };
  },
  /* ---------------- */
  [types.SIGN_OUT](state, action) {
    action.$isSync && window.close();
    return {
      ...initialState,
    };
  },
  /* ---------------- */
  [types.SET_ALREADY_REDIRECT](state, action) {
    return {
      ...state,
      alreadyRedirect: true,
    };
  },
});

export default ProfileReducer;
